import { filter, Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { BooleanInput } from '@angular/cdk/coercion';
import { SharedUserDataService, SharedService } from '@core/services/shared';
import { ManageUserService } from 'app/layout/components-common/user/manage-user.service';
import { manageStorageService } from '@core/services/manage-storage/manage-storage.service';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation, } from '@angular/core';
import { UtilsService } from '@core/services/utils';
import { ApiService } from '@core/services/api';
import { SignOutService } from 'app/modules/public/sign-out/sign-out.service';

@Component({
  selector: "user",
  templateUrl: "./user.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: "user",
})
export class UserComponent implements OnInit, OnDestroy, AfterViewInit {

  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------
  /* eslint-disable @typescript-eslint/naming-convention */
  static ngAcceptInputType_showAvatar: BooleanInput;
  /* eslint-enable @typescript-eslint/naming-convention */

  @Input() showAvatar: boolean = true;
  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  constructor(
    private _router: Router,
    private _api: ApiService,
    private _utilS: UtilsService,
    private _signOutS: SignOutService,
    private _cRef: ChangeDetectorRef,
    private _mStorage: manageStorageService,
    private _shrdUsrInfo: SharedUserDataService,
    private _manageUserService: ManageUserService,
  ) { }
  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------


  user: any;
  lstContracts: any[];
  contractSession: FormControl = new FormControl();
  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------
  private _unsubscribeUsr: Subject<void> = new Subject();

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    this._shrdUsrInfo.getDataUserSession$
      .pipe(
        filter((value) => !this._utilS.isEmpty(value.data)),
        takeUntil(this._unsubscribeUsr)
      )
      .subscribe((dataRecieve) => {
        switch (dataRecieve.origin) {
          case 'reloadContract':
            this.getDataContracts();
            break;
        }
      });

    this.getDataContracts()

  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeUsr.next();
    this._unsubscribeUsr.complete();

  }

  ngAfterViewInit(): void {
    this._cRef.detectChanges();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
  private updateContractSession(selectedContract) {

    if (!this._utilS.isEmpty(selectedContract)) {
      this.contractSession.setValue(selectedContract)
      this.user = selectedContract;

      this._shrdUsrInfo.setDataUserSession(selectedContract, "infoSessionClient");
      let contractSession =  this._mStorage.getPropertie('s_userSession');
      contractSession['contrato'] = selectedContract.contrato;
      contractSession['uuid'] = selectedContract.contratoUuid;
      this._mStorage.overWritePropertie({ nameStorage: 's_userSession', valNew: contractSession}, true)
      this._cRef.markForCheck();
    }

  }
  /**
   * !getDataContracts
   * obtiene los contratos relacionados por usurio
   */
  private getDataContracts() {

    this._manageUserService.getUserDetail()
      .then((rspnsLstContracts: any) => {
        this.lstContracts = rspnsLstContracts;

        this.user = this.lstContracts.find((lstContract) => {
          return lstContract.contratoUuid == this._mStorage.getPropertie('s_userSession')?.uuid
        });

        this.updateContractSession(this.user)
      }).catch((eRR) => {
        console.error('❌ Error al consultar los contratos por usuario', eRR);
      })
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  // Actualizar el nombre del contrato selecciado al cambiar el valor
  changeContract(selectedContract) {

    if (!this._utilS.isEmpty(selectedContract)) {
      this.updateContractSession(selectedContract)
      this._router.navigate(["/dashboard"]);
    }

  }

  /**
   * Sign out
   */
  signOut(): void {
    this._api.logOut()
      .then(() => this._signOutS.processToLogOut(), () => this._signOutS.processToLogOut())
      .catch((errLgOut) => { this._signOutS.processToLogOut(); console.error(errLgOut) })

  }
}
